import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=df5e53c2"
import script from "./SideMenu.ts?vue&type=script&lang=ts&external"
export * from "./SideMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=df5e53c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports